import { Checkbox, Drawer, Label } from "flowbite-react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import {
  customerFilters,
  filterCategories,
  filterCategoryOrder,
} from "../../utils/customerfilterUtils";

const FilterItem = ({ name, isChecked, onToggle }) => {
  return (
    <div className="mb-2 flex cursor-pointer items-center">
      <Checkbox
        id={name}
        color="blue"
        className="mr-2"
        onChange={onToggle}
        checked={isChecked}
      />
      <Label
        htmlFor={name}
        className="flex w-full items-center justify-between"
      >
        <span className="text-gray-700">{name}</span>
      </Label>
    </div>
  );
};

export const CustomersFilter = ({
  isOpen,
  handleClose,
  handleFilterToggle,
  selectedFilters,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer open={isOpen} onClose={handleClose} position="right">
      <Drawer.Header
        title={t("pages.customers.filter_other")}
        titleIcon={() => <></>}
      />
      {filterCategoryOrder.map((categoryKey, idx) => {
        const categoryLabel = filterCategories[categoryKey];
        const categoryFilters = Object.entries(customerFilters).filter(
          ([_, filter]) => filter.category === categoryLabel,
        );

        if (categoryFilters.length === 0) return null;

        return (
          <div key={categoryKey}>
            <h6
              className={cn(
                "mb-2 text-sm font-medium uppercase text-gray-500",
                { "mt-6": idx > 0 },
              )}
            >
              {categoryLabel}
            </h6>
            {categoryFilters.map(([key, filter]) => (
              <FilterItem
                key={key}
                name={filter.name}
                isChecked={selectedFilters.includes(key)}
                onToggle={(e) => handleFilterToggle(e.target.checked, filter)}
              />
            ))}
          </div>
        );
      })}
    </Drawer>
  );
};
